// extracted by mini-css-extract-plugin
export default {"globalColors":"colors_globalColors__e1Fi0","globalColorsDark":"colors_globalColorsDark__xZojr"};